import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { SystemSection } from './components/SystemSection';
import { IncludesSection } from './components/IncludesSection';
import { TransformSection } from './components/TransformSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-terracotta/20" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StorySection data-id="element-2" />
      <SystemSection data-id="element-3" />
      <IncludesSection data-id="element-4" />
      <TransformSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <Footer data-id="element-7" />

      {/* Sticky Mobile CTA */}
      <AnimatePresence data-id="element-8">
        {showStickyCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-cream-dark shadow-[0_-4px_20px_rgba(0,0,0,0.1)] z-50 md:hidden" data-id="element-9">
            <a href="#pricing" className="flex items-center justify-center w-full px-6 py-3 text-white font-bold rounded-xl shadow-md active:scale-95 transition-transform bg-[#DF1189]" data-id="element-10">
              Descargar Plan — $6,39$
            </a>
          </motion.div>}
      </AnimatePresence>
    </div>;
}